/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scl_Toast_Update_PnkInputs */

const vi_scl_toast_update_pnk = /** @type {(inputs: Scl_Toast_Update_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu thay đổi phiếu nhập lô lấy hương`)
};

/**

* @param {Scl_Toast_Update_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scl_toast_update_pnk = /** @type {((inputs?: Scl_Toast_Update_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scl_Toast_Update_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scl_toast_update_pnk(inputs)
});